
import lazyload from "@/directives/lazyload";
import stepOne from "@/assets/images/landing/svg/step-one.svg";
import stepOneMain from "@/assets/images/landing/svg/ll-step-one-img.svg";
import stepTwo from "@/assets/images/landing/svg/step-two-img.svg";
import stepTwoMain from "@/assets/images/landing/svg/step2.svg";
import stepThree from "@/assets/images/landing/svg/step3.svg";
import stepThreeMain from "@/assets/images/landing/svg/step-three-img.svg";
import stepFour from "@/assets/images/landing/svg/step-four-img.svg";
import stepFourMain from "@/assets/images/landing/svg/step4.svg";
export default {
  data() {
    return {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      images: {
        stepOne,
        stepOneMain,
        stepTwo,
        stepTwoMain,
        stepThree,
        stepThreeMain,
        stepFour,
        stepFourMain,
      },
    };
  },
  directives: {
    lazyload,
  },
  props: ['isMob']
};
